import { Directive, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  DeleteUser,
  getDeleteUserActionState,
  getUser,
  IMasterDataState,
  IUserProfileState,
  RequestLogout,
} from '../../+state';
import { isLastnameAsyncValidator } from '../../services';
import { IActionState } from '../../utils';
import { IMasterDataUser, ImmomioIconName, InputType } from '../../models';

@Directive()
export class UserDeletePageBaseComponent implements OnInit {
  public inputType = InputType;
  public immomioIconName = ImmomioIconName;
  public fg: FormGroup;
  public $deleteUserActionState: Observable<IActionState>;
  private $user: Observable<IMasterDataUser>;

  constructor(
    private store: Store<IUserProfileState | IMasterDataState>,
    private fb: FormBuilder
  ) {
    this.$user = this.store.select(getUser);
    this.$deleteUserActionState = this.store.select(getDeleteUserActionState);
    this.fg = this.fb.group({
      deletionConfirmAnswer: ['', [Validators.required], [isLastnameAsyncValidator(this.$user)]],
    });
  }

  ngOnInit() {
    this.store.select(getDeleteUserActionState).subscribe((actionState: IActionState) => {
      if (actionState.done) {
        this.store.dispatch(RequestLogout({ reason: 'auth', userInitiated: true }));
      }
    });
  }

  public deleteAccount() {
    this.store.dispatch(DeleteUser());
  }
}
